import { httpWithoutToken } from "../helper/http-common";

/**
 * Express (lightweight) registration / lead capture.
 * Uses httpWithoutToken to avoid the global 401 interceptor — this form
 * is reachable by guests, and we don't want a backend misconfiguration
 * to redirect users to / mid-form.
 */
class ExpressRegisterDataService {
  SaveExpressRegistration(inputData) {
    return httpWithoutToken.post("/Tools/SaveExpressRegistration", inputData);
  }
  InsertJCKShow2026(inputData) {
    return httpWithoutToken.post("/JCKShow2026/InsertJCKShow2026", inputData);
  }
}

export default new ExpressRegisterDataService();
